export const CURRENCY_SYMBOLS = {
  USD: '$', // US Dollar
  EUR: '€', // Euro
  CRC: '₡', // Costa Rican Colón
  GBP: '£', // British Pound Sterling
  ILS: '₪', // Israeli New Sheqel
  INR: '₹', // Indian Rupee
  JPY: '¥', // Japanese Yen
  KRW: '₩', // South Korean Won
  NGN: '₦', // Nigerian Naira
  PHP: '₱', // Philippine Peso
  PLN: 'zł', // Polish Zloty
  PYG: '₲', // Paraguayan Guarani
  THB: '฿', // Thai Baht
  UAH: '₴', // Ukrainian Hryvnia
  VND: '₫', // Vietnamese Dong
  SGD: 'S$', // Singapore Dollar
  AUD: 'A$', // Australian Dollar
  MYR: 'RM', // Malaysian Ringgit
  IDR: 'Rp', // Indonesian Rupiah
  HKD: '$', // Hong Kong Dollar
};

export const DEFAULT_IMAGE_URL = 'https://react.semantic-ui.com/images/wireframe/image.png';

export const ERROR_VALIDATION_FAILED = 'VALIDATION_FAILED';

export const MALAYSIA_ISO_CODE = 'MY';
export const INDONESIA_ISO_CODE = 'ID';

export const MARKET_COUNTRIES = [
  {
    id: 'SG',
    name: 'Singapore',
  },
  {
    id: 'VN',
    name: 'Vietnam',
  },
  {
    id: 'MY',
    name: 'Malaysia',
  },
  {
    id: 'IN',
    name: 'Indonesia',
  },
  {
    id: 'US',
    name: 'United States',
  },
  {
    id: 'AU',
    name: 'Australia',
  },
];

export const YEAR_OPTIONS = Array.from({ length: 51 }, (_, i) => {
  const year = 2000 + i;
  return { label: year, value: year };
});

export const DEFAULT_DOCUMENT_FILE_TYPES_UPLOAD =
  // eslint-disable-next-line max-len
  '.png, .jpeg, .jpg, .bmp, .tiff, .heic, .gif, text/plain, text/csv, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const fileTypeByMime = (mime = '') => {
  if (mime.includes('image')) {
    return 'image';
  }
  if (mime.includes('pdf')) {
    return 'pdf';
  }
  if (mime.includes('msword') || mime.includes('wordprocessingml.document')) {
    return 'doc';
  }
  if (mime.includes('ms-excel') || mime.includes('sheet') || mime.includes('csv')) {
    return 'xsl';
  }
  return 'file';
};

export const CERT_VOIDED_STATUS = 2;
